"use client";


import { useHeaderContext } from "@context/headerContext";
import { useTopbarContext } from "@context/topbarContext";
import type { HTMLAttributes } from "react";
import { useMemo } from "react";

import StarIcon from "@app/_icons/StarIcon/StarIcon";
import USPItem from "./UspItem";

type HeaderUspsProps = HTMLAttributes<HTMLDivElement>;

const UspList = ({ ...props }: HeaderUspsProps) => {
  const { locale } = useHeaderContext();
  const { uspCollection } = useTopbarContext();
  const items = useMemo(
    () =>
      uspCollection?.items?.filter(
        (item) => item?.__typename === "NavigationLink",
      ),
    [uspCollection?.items],
  );

  if (!items?.length) return null;

  return (
    <div
      className="flex items-center justify-center gap-x-1 overflow-x-auto overflow-y-hidden max-xl:hidden"
      {...props}
    >
      {items.map((item, index) => {
        if (!item) return null;

        return (
          <div key={item.sys.id + index} className="flex items-center gap-x-1">
            <USPItem item={item} locale={locale} />
            {index < items.length - 1 && <StarIcon className="size-2" />}
          </div>
        );
      })}
    </div>
  );
};

UspList.displayName = "UspList";

export default UspList;
